import { render, staticRenderFns } from "./UploadProof.vue?vue&type=template&id=d14a5194&"
import script from "./UploadProof.vue?vue&type=script&lang=js&"
export * from "./UploadProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports